import "../assets/styles/cities.css";
import dogImage from "../assets/images/advertisement/dog-circle.gif";
import naturalImage from "../assets/images/advertisement/natural-paradise.png";

function Cities() {
  return (
    <div className="cities">
      <div className="first_container">
        {/* Selects language options */}
        <select>
          <option value="english">English</option>
        </select>
        <span className="nearby">Nearby</span>
        {/* Displays list of nearby cities/towns */}
        <div className="list">
          <a href="/city">West Melbourne</a>
          <a href="/city">Palm Bay</a>
          <a href="/city">Indian harbor beach</a>
          <a href="/city">Satellite beach</a>
          <a href="/city">South Patrick shores</a>
          <a href="/city">Micco</a>
          <a href="/city">Cocoa Beach</a>
          <a href="/city">Merritt Island</a>
          <a href="/city">Rockledge</a>
          <a href="/city">Sebastian</a>
        </div>
      </div>
      
      {/* advertisement space */}
      <a href="https://www.vetrelief.pet/" target="_blank">
        <p id="probiotic-para">Advertisement</p>

        <div className="ad-space">
          <h4>
            On-demand <br></br>Online Vet Appointments
          </h4>
          <img src={dogImage} width={90} />
          <h4>Book Now</h4>
        </div>
      </a>

      <div  className="for-padding">
      <p id="probiotic-para">Advertisement</p>

      <a
        href="https://www.naturalparadiseoc.com/category-s/1822.htm"
        target="_blank"
       
      >
        <div className="ad-1 ad-image " id="probiotic-img">
          <img src={naturalImage} alt="natural image" />
        </div>
      </a>
      </div>
     
    </div>
  );
}

export default Cities;
